// extracted by mini-css-extract-plugin
export default {"main":"runstring_main__rYULP","but":"runstring_but__6+80I","text":"runstring_text__NpyzV"};